import { makeCell, makeRowSet } from './gridUtill';

let fields = [];
let columns = [];

// ID 컬럼 (숨김 - 데이터 식별용)
makeCell(1, [{ field: 'id', alias: 'ID', indexExclusive: true }], fields, columns);

// ID 컬럼을 숨김 처리
if (columns.length > 0) {
  columns[columns.length - 1].visible = false;
}

// 고객사 원료명칭 컬럼
makeCell(
  1,
  [
    {
      field: 'customerMaterialName',
      alias: '고객사 원료명칭',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);

// 사내통용 원료명칭 컬럼 (돋보기 버튼 포함)
makeCell(
  1,
  [
    {
      field: 'internalMaterialName',
      alias: '사내통용 원료명칭',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
  null, // width
  true, // editable
  {
    type: 'html',
    callback: function (grid, cell) {
      const value = cell.value || '';
      const fieldName = cell.column ? cell.column.fieldName || 'internalMaterialName' : 'internalMaterialName';
      const rowIndex = cell.index.itemIndex;

      // 해당 행의 ID 값 확인 (ID 있으면 기존 데이터)
      const rowData = grid.getDataSource().getJsonRow(cell.index.dataRow);
      const hasId = rowData && rowData.id != null && rowData.id !== '';

      if (hasId) {
        // 기존 로우: 값만 표시 (돋보기 숨김)
        return `<div style="display: flex; align-items: center; height: 100%; padding: 0 5px;"><span style="flex: 1;">${value}</span></div>`;
      }

      // 신규 로우: 돋보기 표시 및 클릭 시 모달 열기
      if (value.trim() === '') {
        // 값이 비어있으면 돋보기 아이콘만 표시
        return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: center; height: 100%; cursor: pointer;">
                  <i class="mdi mdi-magnify" style="font-size: 16px; color: #666;"></i>
                </div>`;
      } else {
        // 값이 있으면 값과 돋보기 아이콘을 함께 표시
        return `<div onclick="window.openSearchModal && window.openSearchModal('${fieldName}', ${rowIndex})" style="display: flex; align-items: center; justify-content: space-between; height: 100%; padding: 0 5px; cursor: pointer;">
                  <span style="flex: 1;">${value}</span>
                  <i class="mdi mdi-magnify" style="font-size: 14px; margin-left: 5px; color: #666;"></i>
                </div>`;
      }
    },
  },
);

// 비고 컬럼
makeCell(
  1,
  [
    {
      field: 'remark',
      alias: '비고',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);

// 등록일 컬럼
makeCell(1, [{ field: 'regDate', alias: '등록일', indexExclusive: true }], fields, columns);

// 등록자 컬럼
makeCell(1, [{ field: 'regUser', alias: '등록자', indexExclusive: true }], fields, columns);

const rowSet = makeRowSet(fields);
const errorMessage = '고객사 원료명칭 데이터가 없습니다';
const hideCheckBar = false; // 체크박스 활성화

export { fields, columns, rowSet, errorMessage, hideCheckBar };
